<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <!-- <v-overlay :value="loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- {{org_id}} -->
        <span v-if="org_id == 'zeal' || org_id == 'uwws'">
            <fee-structure-installment-zeal></fee-structure-installment-zeal>
        </span>
        <span v-else-if="org_id == 'vvp'">
            <fee-structure-installment-vvp></fee-structure-installment-vvp>
        </span>
        <span v-else-if="org_id == 'wws'">
            <fee-structure-installment-wws></fee-structure-installment-wws>
        </span>
        <span v-else-if="org_id == 'sbpps'">
            <fee-structure-installment-sbpps></fee-structure-installment-sbpps>
        </span>
        <span v-else-if="org_id == 'eps'">
            <fee-structure-installment-eps></fee-structure-installment-eps>
        </span>
        <span v-else>
            <fee-structure-installment-other></fee-structure-installment-other>
        </span>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    // import FeesStructureInstallmentSBPPS from "./FeesStructureInstallmentSBPPS";
    // import FeesStructureInstallmentWWS from "./FeesStructureInstallmentWWS";
    // import FeesStructureInstallmentZeal from "./FeesStructureInstallmentZeal";
    // import FeesStructureInstallmentVVP from "./FeesStructureInstallmentVVP";
    // import FeesStructureInstallmentOther from "./FeesStructureInstallmentOther";
// import FeesStructureInstallmentEPS from "./FeesStructureInstallmentEPS";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components: {
            "fee-structure-installment-sbpps": () => import('./FeesStructureInstallmentSBPPS'),
            "fee-structure-installment-wws": () => import('./FeesStructureInstallmentWWS'),
            "fee-structure-installment-zeal": () => import('./FeesStructureInstallmentZeal'),
            "fee-structure-installment-vvp": () => import('./FeesStructureInstallmentVVP'),
            "fee-structure-installment-other": () => import('./FeesStructureInstallmentOther'),
            "fee-structure-installment-eps": () => import('./FeesStructureInstallmentEPS'),
            Breadcrumbs
        },
        data: () => ({
            org_id: null,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
        }),
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.org_id = localStorage.getItem("EPS-tenant");
        },
        watch: {},
    };
</script>
<style scoped>
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
